import { render, staticRenderFns } from "./IconVolumeUpSolid.vue?vue&type=template&id=6eb3f1ba"
import script from "./IconVolumeUpSolid.vue?vue&type=script&lang=js"
export * from "./IconVolumeUpSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports